import { Heading5 } from "../../../ui/texts/TextStyle"

const BodyTitle = ({ title }: { title: string }) => {
	return <Heading5 className="font-semibold">{title}</Heading5>
}

export default BodyTitle
